import { render, staticRenderFns } from "./BdKb.vue?vue&type=template&id=434d9d42&"
import script from "./BdKb.vue?vue&type=script&lang=js&"
export * from "./BdKb.vue?vue&type=script&lang=js&"
import style0 from "./BdKb.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports